import { dispatchAction } from '@ardoq/rxbeach';
import {
  addDefaultFilter,
  changeFilterCondition,
  updateFilter,
  ChangeFilterConditionPayload,
  UpdateFilterPayload,
  deleteFilter,
  DeleteFilterPayload,
} from './viewpointBuilderFilterActions';
import * as editTraversalActions from '../traversals/editTraversalActions';
import { viewpointBuilderTracking } from '../viewpointBuilderTracking';

export const getViewpointBuilderFiltersCommands = (namespace: string) => ({
  addDefaultFilter: (graphNodeId: string) => {
    dispatchAction(addDefaultFilter({ graphNodeId }), namespace);
  },

  toggleIsSelectedGraphNode: (graphNodeId: string) => {
    viewpointBuilderTracking.trackComponentTypeNodeSelectedInGraph(
      'FILTERS_TAB'
    );
    dispatchAction(
      editTraversalActions.toggleIsSelectedGraphNode({ graphNodeId }),
      namespace
    );
  },

  toggleIsSelectedGraphEdge: (graphEdgeId: string) =>
    dispatchAction(
      editTraversalActions.toggleIsSelectedGraphEdge({ graphEdgeId }),
      namespace
    ),

  changeFilterCondition: ({
    graphNodeId,
    condition,
  }: ChangeFilterConditionPayload) => {
    dispatchAction(
      changeFilterCondition({
        graphNodeId,
        condition,
      }),
      namespace
    );
  },

  updateFilter: (payload: UpdateFilterPayload) =>
    dispatchAction(updateFilter(payload), namespace),

  deleteFilter: (payload: DeleteFilterPayload) =>
    dispatchAction(deleteFilter(payload), namespace),
});

export type ViewpointBuilderFiltersCommands = ReturnType<
  typeof getViewpointBuilderFiltersCommands
>;

export type AddFilterCommands = Pick<
  ViewpointBuilderFiltersCommands,
  'addDefaultFilter'
>;

export type ChangeConditionCommands = Pick<
  ViewpointBuilderFiltersCommands,
  'changeFilterCondition'
>;

export type EditFilterCommands = Pick<
  ViewpointBuilderFiltersCommands,
  'updateFilter' | 'deleteFilter'
>;

export type ToggleIsSelectedGraphNodeCommands = Pick<
  ViewpointBuilderFiltersCommands,
  'toggleIsSelectedGraphNode' | 'toggleIsSelectedGraphEdge'
>;
